// @flow

/**
 * Module dependencies.
 */

import { get } from 'lodash';
import config from 'config';

/**
 * Property id.
 */

const propertyId = get(config, 'tawkTo.propertyId');

/**
 * Widget id.
 */

const widgetId = get(config, 'tawkTo.widgetId');

/**
 * Export `tawkTo`.
 */

export function tawkTo() {
  if (!window) {
    return;
  }

  window.Tawk_API = window.Tawk_API || {}; // eslint-disable-line id-match
  window.Tawk_LoadStart = new Date(); // eslint-disable-line id-match

  const tawkId = document.getElementById('tawkId');

  if (tawkId) {
    return window.Tawk_API;
  }

  const script = document.createElement('script');

  script.id = 'tawkId';
  script.async = true;
  script.src = `https://embed.tawk.to/${propertyId}/${widgetId}`;
  script.charset = 'UTF-8';
  script.setAttribute('crossorigin', '*');

  const scriptTagName = document.getElementsByTagName('script')[0];

  if (scriptTagName && scriptTagName.parentNode) {
    scriptTagName.parentNode.insertBefore(script, scriptTagName);
  }
}



// WEBPACK FOOTER //
// ../src/client/core/utils/tawk-to.js